export default class StringValidation {
    constructor (dto) {
        this.maxLength = dto ? dto.MaxLength : ''
    }
}
